<template>
  <v-container fluid class="homepage-dev-container">
    <v-row class="homepage-dev">
      <div class="bg-dots-gray--home" ref="bgDotsGrayHome"></div>

      <v-col sm="12" class="pl-6 pr-0">
        <h1 class="mb-3 text-h3 grey--text text--darken-3">Desenvolvimento Portal</h1>

        <p class="font-weight-regular text-body-1 grey--text text--darken-3">
          Bem vindo a ferramenta de desenvolvimento do novo portal I4PRO.
          <br />Com ela vamos poder configurar o visual, menus, criar e editar <br />suas telas de uma maneira simples.
        </p>
      </v-col>

      <v-col sm="7">
        <v-row :class="['cards-navigation', !selectedPortal && 'cards-navigation__disabled']">
          <v-col @click="handleLoadTemplate(menu.template)" class="card-navigation__wrapper" v-for="(menu, index) in menus" :key="index">
            <v-card class="card-navigation">
              <lottie :options="menu.options" :widthAnimation="null" :animationOnMouseMove="true" class="card-lottie" />
            </v-card>

            <div :class="`card-navigation--element-0${item}`" v-for="item in 8" :key="item" />

            <h3 class="font-weight-bold text-subtitle-1 grey--text text--darken-3">{{ menu.title }}</h3>
          </v-col>
        </v-row>
      </v-col>

      <v-col sm="5">
        <lottie :options="defaultOptions" :widthAnimation="null" class="animation-json" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as HANDLERS from '@/helpers/types/handlers';
import devComponentMixin from '@/mixins/dev-component-mixin';

import defaultJson from '@/assets/lottie/default.json';
import menuJson from '@/assets/lottie/menu.json';
import layoutJson from '@/assets/lottie/layout.json';
import pageJson from '@/assets/lottie/page.json';

export default {
  mixins: [devComponentMixin],

  components: {
    lottie: () => import('@/components/lottie/i4pro-lottie')
  },

  data() {
    return {
      defaultOptions: { json: defaultJson },
      menus: [
        { title: 'Cadastro de menu', template: 'templateMenu', options: { json: menuJson } },
        { title: 'Configuração de layout', template: 'templateLayoutConfig', options: { json: layoutJson } },
        { title: 'Desenvolvimento de páginas', template: 'templatePage', options: { json: pageJson } }
      ]
    };
  }
};
</script>
